export default {
    name: 'KPI',
    data() {
        return {
            ErrorCodes: [],
            ErrorCode: '',
            End: '',
            Results: [],
            Start: moment().format('YYYY-MM-DD'),
            StartHour: '00',
            EndHour: '23',
        };
    },
    mounted() {
        window.model = this;
        $('#filterOther').hide();
        this.load();
    },
    methods: {
        async load() {
            this.ErrorCodes = await this.$api.getErrorCodes();
            this.filter();
        },
        async filter() {
            var result = await this.$api.getErrorReport(this.ErrorCode);
            this.createDataTable('#tableWeek', result.Week.Column, result.Week.Data, {
                bSort: false, searching: false, paging: false,
                buttons: [{
                    extend: "excelHtml5",
                    className: "hide",
                    autoFilter: true,
                    text: "excel",
                    title: "機台報警異常故障統計"
                }, {
                    extend: "csv",
                    className: "hide",
                    autoFilter: true,
                    text: "csv",
                    title: "機台報警異常故障統計"
                }]
            });

            this.createDataTable('#tableMonth', result.Month.Column, result.Month.Data, {
                bSort: false, searching: false, paging: false,
                buttons: [{
                    extend: "excelHtml5",
                    className: "hide",
                    autoFilter: true,
                    text: "excel",
                    title: "機台報警異常故障統計"
                }, {
                    extend: "csv",
                    className: "hide",
                    autoFilter: true,
                    text: "csv",
                    title: "機台報警異常故障統計"
                }]
            });

            this.createDataTable('#tableYear', result.Year.Column, result.Year.Data, {
                bSort: false, searching: false, paging: false,
                buttons: [{
                    extend: "excelHtml5",
                    className: "hide",
                    autoFilter: true,
                    text: "excel",
                    title: "機台報警異常故障統計"
                }, {
                    extend: "csv",
                    className: "hide",
                    autoFilter: true,
                    text: "csv",
                    title: "機台報警異常故障統計"
                }]
            });

            var rs=  await this.$api.searchErrorReport(`${this.Start} ${this.StartHour}:00:00`, `${this.Start} ${this.EndHour}:59:59`);
            this.createDataTable('#tableHistory', [
                {title: "故障時間", data: "StartTime",
                render: window.filters.dateTimeFormat},
                {title: "故障代碼", data: "ErrorCode"},
                {title: "故障說明", data: "Description"}
            ], rs, {
                bSort: false, searching: false, paging: false,
                buttons: [{
                    extend: "excelHtml5",
                    className: "hide",
                    autoFilter: true,
                    text: "excel",
                    title: "機台報警異常故障統計"
                }, {
                    extend: "csv",
                    className: "hide",
                    autoFilter: true,
                    text: "csv",
                    title: "機台報警異常故障統計"
                }]
            });
        },
        async search() {
            if (!this.Start || !this.End) {
                alert('請選擇搜尋區間');
                return;
            }
            this.Results = await this.$api.searchErrorReport(this.Start, this.End);
            window.$('#modal-check-alarmError-list').modal();
        },
        async search2() {
            if (!this.Start || !this.StartHour || !this.EndHour) {
                alert('請選擇搜尋區間');
                return;
            }
            this.Results = await this.$api.searchErrorReport(`${this.Start} ${this.StartHour}:00:00`, `${this.Start} ${this.EndHour}:59:59`);
        },
        exportCSV() {
            $('.tab-pane.active button.buttons-csv').trigger('click');
        },
        exportExcel() {
            $('.tab-pane.active button.buttons-excel').trigger('click');
        },
        showHistory(isHistory){
            if(isHistory){
                $('#filterHostory').show();
                $('#filterOther').hide();
            }else{                
                $('#filterOther').show();
                $('#filterHostory').hide();
            }
        }
    },
    watch:{
        ErrorCode(value){
            if(window.mobile){
                window.$('#modal-search-filter').modal('hide');
            }
        }
    }
}